module.exports = __webpack_public_path__ + "static/img/feature_3.8657049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/feature_3.png
// module id = XPqn
// module chunks = 0